export default "__VITE_ASSET__ILj_P3Hw__"